import { OUTCOMES } from "@/data/content";

export const OutcomesSection = () => {
  const scrollToAudit = (e) => {
    e.preventDefault();
    const el = document.getElementById("visibility-audit");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <section
      data-testid="outcomes-parallax-section"
      className="relative py-16 md:py-24 bg-[#0b0b0c] bg-parallax"
      style={{ backgroundImage: `url(${OUTCOMES.bg})` }}
    >
      <div className="absolute inset-0 bg-[rgba(2,2,2,0.78)]" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-14 items-center">
          {/* Scorecard visual (replaces dated PNG graphic) */}
          <div
            data-testid="outcomes-scorecard"
            className="rounded-[14px] border border-white/10 bg-white/[0.05] backdrop-blur-sm p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.4)]"
          >
            <div className="flex items-center justify-between">
              <h4 className="font-nunito text-sm font-extrabold uppercase tracking-[0.2em] text-white">
                {OUTCOMES.scorecard.title}
              </h4>
              <span className="h-2.5 w-2.5 rounded-full bg-[#ee2e24] animate-pulse" />
            </div>
            <div className="mt-6 space-y-5">
              {OUTCOMES.scorecard.rows.map((row) => (
                <div key={row.label}>
                  <div className="flex items-center justify-between gap-4">
                    <p className="text-[13px] text-[#cfcfcf]">{row.label}</p>
                    <span className="font-nunito text-[11px] font-extrabold uppercase tracking-[0.12em] text-[#ff6b63]">
                      {row.display}
                    </span>
                  </div>
                  <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-[#ee2e24] to-[#ff6b63]"
                      style={{ width: `${row.value}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-6 text-[11px] text-[#8a8a8a]">{OUTCOMES.scorecard.caption}</p>
          </div>

          {/* Bullets */}
          <div>
            <h3 className="font-nunito text-3xl md:text-4xl font-extrabold text-white heading-redul">
              {OUTCOMES.heading}
            </h3>
            <ul className="mt-8 space-y-5">
              {OUTCOMES.bullets.map((b) => {
                const Icon = b.icon;
                return (
                  <li key={b.text} className="flex items-center gap-4">
                    <span className="shrink-0 h-10 w-10 rounded-full border border-white/20 bg-white/[0.06] flex items-center justify-center">
                      <Icon size={18} strokeWidth={1.75} className="text-[#ee2e24]" />
                    </span>
                    <span className="text-[15px] md:text-base font-medium text-[#ececec]">{b.text}</span>
                  </li>
                );
              })}
            </ul>
            <a
              href="#visibility-audit"
              onClick={scrollToAudit}
              data-testid="outcomes-cta-button"
              className="mt-9 inline-flex items-center rounded-[10px] bg-[#ee2e24] px-7 py-3.5 font-nunito text-[13px] font-extrabold uppercase tracking-[0.12em] text-white shadow-[0_14px_40px_rgba(238,46,36,0.35)] hover:bg-[#d92820] active:scale-[0.98] transition-colors duration-150"
            >
              Get My Free Visibility Audit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
